export const localStorageAdapter = {
  getItem(key) {
    return JSON.parse(localStorage.getItem(key));
  },

  removeItem(key) {
    localStorage.removeItem(key);
  },

  setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};



// WEBPACK FOOTER //
// ./src/core/utils/local-storage.js